// Nada secreto puede vivir en este archivo: todo lo que está acá se compila
// dentro del bundle y viaja al navegador de cada visitante.
//
// Acá había un access token de Meta/WhatsApp hardcodeado, usado para enviar
// mensajes directo desde el navegador. Se quitó y se revocó en Meta. El envío
// de WhatsApp es multi-tenant y vive en el servidor (services/whatsappService.js,
// con el accessToken de cada hotel en WhatsappConfig).
export const constant = {
  baseUrl: process.env.REACT_APP_BASE_URL.endsWith('/') ? process.env.REACT_APP_BASE_URL : process.env.REACT_APP_BASE_URL + '/'
};
